import React from 'react';

import {  LanguageSelector as BaseLanguageSelector } from 'handimap-react-lib/components/LanguageSelector';
import { Language } from '../enum/language';

export const LanguageSelector = () => {
  return (
    <BaseLanguageSelector languageList={Language}/>
  );
};